var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmokeAlarmSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1999 6.49512C17.5889 6.49512 17.9046 6.81085 17.9046 7.19988C17.9046 7.58891 17.5889 7.90464 17.1999 7.90464C16.8109 7.90464 16.4951 7.58891 16.4951 7.19988C16.4951 6.81085 16.8109 6.49512 17.1999 6.49512Z",
    fill: "#9393B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2666 2.2666C17.7158 2.2666 22.1332 6.68404 22.1332 12.1333C22.1332 17.5825 17.7158 21.9999 12.2666 21.9999C6.81735 21.9999 2.3999 17.5825 2.3999 12.1333C2.3999 6.68404 6.81735 2.2666 12.2666 2.2666Z",
    stroke: "#9393B0",
    strokeWidth: 1.40952
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7125 12.8379C15.432 14.2143 14.3509 15.3017 12.9717 15.5822V17.0115C13.0344 17.0023 13.0971 16.9967 13.1591 16.9854C15.1889 16.6147 16.7851 14.9987 17.1305 12.964C17.1375 12.9225 17.1354 12.8795 17.141 12.8379H15.7125Z",
    fill: "#9393B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1326 11.3095C16.783 9.23326 15.1522 7.60808 13.0753 7.26557C13.0415 7.25993 13.0055 7.26275 12.9717 7.25781V8.68777C14.3537 8.96827 15.4327 10.0458 15.7132 11.4286H17.1425C17.1368 11.3891 17.1389 11.3482 17.1326 11.3095Z",
    fill: "#9393B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.562 15.5787C10.1814 15.2975 9.10097 14.2206 8.82048 12.8379H7.39404C7.40039 12.8837 7.39827 12.9309 7.40602 12.9767C7.76193 15.0403 9.38852 16.657 11.4535 16.9995C11.4887 17.0051 11.5261 17.0037 11.562 17.0087V15.5787Z",
    fill: "#9393B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82281 11.4283C9.1033 10.0505 10.1781 8.96518 11.5622 8.68398V7.26318C11.4974 7.27235 11.429 7.27023 11.3649 7.28221C9.30839 7.66278 7.7121 9.30629 7.39144 11.3741C7.38862 11.3917 7.39003 11.41 7.38721 11.4283H8.82281Z",
    fill: "#9393B0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2665 10.7236C13.0452 10.7236 13.676 11.3544 13.676 12.1332C13.676 12.9119 13.0452 13.5427 12.2665 13.5427C11.4877 13.5427 10.8569 12.9119 10.8569 12.1332C10.8569 11.3544 11.4877 10.7236 12.2665 10.7236Z",
    stroke: "#9393B0",
    strokeWidth: 1.40952
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokeAlarmSvgrepocom);
export default __webpack_public_path__ + "static/media/smoke-alarm_svgrepo.com.71cee4c638008ceb49ac3e59a4dfb92c.svg";
export { ForwardRef as ReactComponent };